@if (currentUserId) {

<div
    class="tw-flex tw-h-[calc(100dvh-65px)] tw-overflow-y-hidden tw-bg-gradient-to-br tw-from-gray-50 tw-to-gray-100 dark:tw-from-gray-900 dark:tw-to-gray-800">
    <div *ngIf="isViewportReady"
        class="tw-min-h-[calc(100dvh-65px)] tw-w-full md:tw-w-80 lg:tw-w-96 tw-bg-white dark:tw-bg-gray-900 tw-border-r tw-border-gray-200 dark:tw-border-gray-700 tw-overflow-y-auto"
        [ngClass]="{
        'tw-translate-x-0': showConversationList(),
        'tw--translate-x-full tw-absolute tw-z-50': !showConversationList() && isMobileView(),
        'tw-w-20 md:tw-w-20 lg:tw-w-20 xl:tw-w-32': collapsedSidebar(),
        'tw-hidden': !showConversationList() && !isMobileView()
     }">

        <!-- Compact Header -->
        <div class="tw-p-4 tw-bg-white dark:tw-bg-gray-900 tw-sticky tw-top-0 tw-z-20">

            <!-- Title and New Chat Button -->
            @if (!collapsedSidebar()) {
            <div class="tw-flex tw-items-center tw-justify-between tw-mb-3">
                <h2 class="tw-text-xl tw-font-semibold tw-text-gray-900 dark:tw-text-white">Chats</h2>
                <button (click)="openUserSelectionModal()"
                    class="tw-flex tw-p-2 tw-rounded-full tw-text-gray-600 dark:tw-text-gray-300 hover:tw-bg-gray-100 dark:hover:tw-bg-gray-800 tw-transition-colors">
                    <ng-icon name="heroUserPlus" size="20"></ng-icon>
                </button>
            </div>
            }
 
            @if (collapsedSidebar()) {
            <div class="tw-flex tw-justify-center tw-mb-3">
                <button (click)="openUserSelectionModal()"
                    class="tw-flex tw-p-2 tw-rounded-full tw-text-gray-600 dark:tw-text-gray-300 hover:tw-bg-gray-100 dark:hover:tw-bg-gray-800 tw-transition-colors"
                    matTooltip="New Chat" matTooltipPosition="right">
                    <ng-icon name="heroUserPlus" size="20"></ng-icon>
                </button>
            </div>
            }

            <!-- Compact Search Bar -->
            @if (!collapsedSidebar()) {
            <div class="tw-relative tw-mb-3">
                <div class="tw-absolute tw-inset-y-0 tw-left-0 tw-pl-3 tw-flex tw-items-center tw-pointer-events-none">
                    <ng-icon name="heroMagnifyingGlass" size="16" class="tw-text-gray-400"></ng-icon>
                </div>
                <input type="text" placeholder="Search or start new chat"
                    class="tw-w-full tw-pl-10 tw-pr-4 tw-py-2 tw-bg-gray-100 dark:tw-bg-gray-800 tw-border-0 tw-rounded-lg tw-text-sm tw-text-gray-900 dark:tw-text-white tw-placeholder-gray-500 focus:tw-outline-none focus:tw-bg-white dark:focus:tw-bg-gray-700 focus:tw-ring-2 focus:tw-ring-blue-500"
                    [ngModel]="searchQuery()" (ngModelChange)="searchQuery.set($event)" />
            </div>
            }

            <!-- Minimal Underline Filter -->
            @if (!collapsedSidebar()) {
            <div class="tw-flex tw-border-b tw-border-gray-200 dark:tw-border-gray-700">
                <button (click)="setFilter('all')" [class]="getUnderlineFilterClasses('all')">
                    <span>All</span>
                    @if (totalConversations > 0) {
                    <span class="tw-ml-1 tw-text-xs tw-opacity-75">({{ totalConversations }})</span>
                    }
                </button>

                <button (click)="setFilter('unread')" [class]="getUnderlineFilterClasses('unread')">
                    <span>Unread</span>
                    @if (filteredUnreadConversations > 0) {
                    <span class="tw-ml-1 tw-text-red-500">
                        ({{ filteredUnreadConversations }})
                    </span>
                    }
                </button>

                <button (click)="setFilter('active')" [class]="getUnderlineFilterClasses('active')">
                    <span>Active</span>
                    @if (filteredOnlineConversations > 0) {
                    <span class="tw-ml-1 tw-w-2 tw-h-2 tw-bg-green-500 tw-rounded-full tw-inline-block"></span>
                    }
                </button>
            </div>
            }


        </div>

        <!-- User Requests Section -->
        @if (filteredUserRequests().length > 0) {
        <div class="tw-px-4 tw-mb-2">
            <app-user-requests-preview [requests]="filteredUserRequests" (viewAllRequests)="openUserRequestsModal()"
                (acceptRequest)="acceptUserRequest($event)" (rejectRequest)="rejectUserRequest($event)">
            </app-user-requests-preview>
        </div>
        }

        <!-- Conversations List -->
        <div class="tw-flex-1 tw-px-4">
            <div *ngIf="conversationsLoading() && filteredConversations().length === 0">
                <app-conversation-list-skeleton [itemCount]="6" [collapsedSidebar]="collapsedSidebar()">
                </app-conversation-list-skeleton>
            </div>

            <div *ngIf="!conversationsLoading() || filteredConversations().length > 0">
                @for (conversation of filteredConversations(); track conversation._id) {
                <div (click)="selectConversation(conversation._id)"
                    class="tw-relative tw-cursor-pointer tw-px-4 tw-py-3 hover:tw-bg-gray-50 dark:hover:tw-bg-gray-800 tw-transition-colors tw-border-b tw-border-gray-100 dark:tw-border-gray-800"
                    [ngClass]="{
                    'tw-bg-gray-100 dark:tw-bg-gray-800': activeConversation() === conversation._id,
                    'tw-px-3': collapsedSidebar()
                 }">

                    <div class="tw-flex tw-items-center tw-space-x-3">
                        <!-- Avatar -->
                        <div class="tw-relative tw-flex-shrink-0">
                            @if (conversation.profilePictureKey.includes('Avatar')) {
                            <div [class]="collapsedSidebar() ? 'tw-w-10 tw-h-10' : 'tw-w-12 tw-h-12'">
                                <app-user-avatar [pictureKey]="conversation.profilePictureKey"
                                    [pictureTransform]="conversation.pictureTransform" [pictureID]="conversation._id">
                                </app-user-avatar>
                            </div>
                            } @else {
                            <img [class]="collapsedSidebar() ? 'tw-w-10 tw-h-10' : 'tw-w-12 tw-h-12'"
                                class="tw-rounded-full tw-object-cover"
                                [src]="profileApiUrl + conversation.profilePictureKey"
                                [style.transform]="'rotate(' + conversation.pictureTransform + 'deg)'"
                                [alt]="conversation.firstName + ' ' + conversation.lastName" loading="lazy">
                            }

                            <!-- Online Status -->
                            <div class="tw-absolute tw--bottom-0 tw--right-0">
                                <div class="tw-w-3 tw-h-3 tw-rounded-full tw-border-2 tw-border-white dark:tw-border-gray-900"
                                    [class]="conversation.isOnline ? 'tw-bg-green-500' : 'tw-bg-gray-400'"></div>
                            </div>

                            <!-- Unread Count Badge -->
                            @if (conversation.unreadCount > 0) {
                            <div class="tw-absolute tw--top-1 tw--right-1">
                                <span
                                    class="tw-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center tw-rounded-full tw-bg-green-500 tw-text-white tw-text-xs tw-font-medium">
                                    {{ conversation.unreadCount > 9 ? '9+' : conversation.unreadCount }}
                                </span>
                            </div>
                            }
                        </div>

                        <!-- Chat Info -->
                        @if (!collapsedSidebar()) {
                        <div class="tw-flex-1 tw-min-w-0">
                            <div class="tw-flex tw-items-center tw-justify-between">
                                <p
                                    class="tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-white tw-truncate tw-mb-0">
                                    {{ conversation.firstName }} {{ conversation.lastName }}
                                </p>
                                <p class="tw-text-xs tw-ml-2 tw-shrink-0 tw-mb-0 tw-transition-all tw-duration-200"
                                    [ngClass]="{
     'tw-text-blue-600 dark:tw-text-blue-400 tw-font-bold tw-bg-blue-50 dark:tw-bg-blue-900/20 tw-px-2 tw-py-0.5 tw-rounded-md': conversation.unreadCount > 0,
     'tw-text-gray-500 dark:tw-text-gray-400 tw-font-medium': conversation.unreadCount === 0
   }">
                                    {{ formatConversationTime(conversation.time) }}
                                </p>

                            </div>
                            <p class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-400 tw-truncate tw-mt-1 tw-mb-0"
                                [class.tw-font-medium]="conversation.unreadCount > 0"
                                [class.tw-text-gray-900]="conversation.unreadCount > 0"
                                [class.dark:tw-text-white]="conversation.unreadCount > 0">
                                {{ conversation.lastMessage }}
                            </p>
                        </div>
                        }
                    </div>

                    <!-- Active Conversation Indicator -->
                    @if (activeConversation() === conversation._id) {
                    <div class="tw-absolute tw-left-0 tw-top-0 tw-bottom-0 tw-w-1 tw-bg-blue-500"></div>
                    }
                </div>
                }
            </div>

            <!-- Dynamic Empty State -->
            @if (!conversationsLoading() && filteredConversations().length === 0) {
            <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-16 tw-px-6 tw-text-center">
                <div
                    class="tw-w-16 tw-h-16 tw-rounded-full tw-bg-gray-100 dark:tw-bg-gray-800 tw-flex tw-items-center tw-justify-center tw-mb-4">
                    <ng-icon [name]="getEmptyStateContent().icon" size="24" class="tw-text-gray-400"></ng-icon>
                </div>
                <h3 class="tw-text-lg tw-font-medium tw-text-gray-900 dark:tw-text-white tw-mb-2">
                    {{ getEmptyStateContent().title }}
                </h3>
                <p class="tw-text-sm tw-text-gray-500 tw-mb-4 tw-max-w-sm tw-leading-relaxed">
                    {{ getEmptyStateContent().message }}
                </p>

                <!-- Conditional Action Button -->
                @if (activeFilter() === 'all') {
                <button (click)="openUserSelectionModal()"
                    class="tw-px-4 tw-py-2 tw-bg-blue-500 tw-text-white tw-text-sm tw-font-medium tw-rounded-lg hover:tw-bg-blue-600 tw-transition-colors">
                    New Chat
                </button>
                } @else if (activeFilter() === 'unread') {
                <button (click)="setFilter('all')"
                    class="tw-px-4 tw-py-2 tw-bg-gray-100 dark:tw-bg-gray-800 tw-text-gray-700 dark:tw-text-gray-300 tw-text-sm tw-font-medium tw-rounded-lg hover:tw-bg-gray-200 dark:hover:tw-bg-gray-700 tw-transition-colors">
                    View All Chats
                </button>
                } @else if (activeFilter() === 'active') {
                <div class="tw-flex tw-gap-2">
                    <button (click)="setFilter('all')"
                        class="tw-px-4 tw-py-2 tw-bg-gray-100 dark:tw-bg-gray-800 tw-text-gray-700 dark:tw-text-gray-300 tw-text-sm tw-font-medium tw-rounded-lg hover:tw-bg-gray-200 dark:hover:tw-bg-gray-700 tw-transition-colors">
                        View All Chats
                    </button>
                    <button (click)="openUserSelectionModal()"
                        class="tw-px-4 tw-py-2 tw-bg-blue-500 tw-text-white tw-text-sm tw-font-medium tw-rounded-lg hover:tw-bg-blue-600 tw-transition-colors">
                        Start New Chat
                    </button>
                </div>
                }
            </div>
            }

        </div>
    </div>

    <div class="tw-flex-1 tw-flex tw-flex-col tw-bg-gradient-to-br tw-from-slate-50/50 tw-via-white/30 tw-to-indigo-50/30 dark:tw-from-slate-950/80 dark:tw-via-slate-900/50 dark:tw-to-indigo-950/30 tw-backdrop-blur-xl"
        [ngClass]="{ 'tw-hidden md:tw-flex': showConversationList() && isMobileView(), 'tw-flex': !showConversationList() || !isMobileView()}">

        @if (activeConversation()) {
        <header
            class="tw-sticky tw-top-0 tw-z-50 tw-bg-white/95 tw-backdrop-blur-xl tw-border-b tw-border-slate-200/50 dark:tw-border-slate-700/50 dark:tw-bg-slate-900/95 tw-transition-all tw-duration-300">
            <div class="tw-relative tw-px-4 tw-py-3">
                <div class="tw-flex tw-items-center tw-justify-between tw-mx-auto">
                    <div class="tw-flex tw-items-center tw-gap-4 tw-flex-1 tw-min-w-0">
                        @if (isMobileView()) {
                        <button (click)="backToConversations()"
                            class="tw-group tw-flex tw-items-center tw-justify-center tw-w-9 tw-h-9 tw-rounded-xl tw-bg-gray-100/80 dark:tw-bg-gray-800/80 tw-text-gray-600 dark:tw-text-gray-400 hover:tw-bg-gray-200/80 dark:hover:tw-bg-gray-700/80 hover:tw-text-gray-900 dark:hover:tw-text-gray-200 tw-transition-all tw-duration-200 hover:tw-scale-105 tw-active:scale-95 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500/30 dark:focus:tw-ring-blue-400/30"
                            aria-label="Back to conversations">
                            <ng-icon name="heroArrowLeft" size="18"
                                class="group-hover:tw--translate-x-0.5 tw-transition-transform tw-duration-200"></ng-icon>
                        </button>
                        }

                        <div class="tw-relative tw-group">
                            <div
                                class="tw-relative tw-overflow-hidden tw-rounded-full tw-ring-2 tw-ring-white dark:tw-ring-gray-900 tw-shadow-lg tw-shadow-black/10 dark:tw-shadow-black/30 tw-transition-all tw-duration-300 group-hover:tw-shadow-xl group-hover:tw-shadow-black/20 dark:group-hover:tw-shadow-black/40">
                                @if (activeConversationData()?.profilePictureKey?.includes('Avatar')) {
                                <div
                                    class="tw-w-12 tw-h-12 tw-object-cover tw-transition-transform tw-duration-300 group-hover:tw-scale-110">
                                    <app-user-avatar [pictureKey]="activeConversationData()?.profilePictureKey || ''"
                                        [pictureTransform]="activeConversationData()?.pictureTransform || 0"
                                        [pictureID]="activeConversationData()?._id || ''">
                                    </app-user-avatar>
                                </div>
                                } @else {
                                <img class="tw-w-12 tw-h-12 tw-object-cover tw-transition-transform tw-duration-300 group-hover:tw-scale-110"
                                    [src]="[profileApiUrl+activeConversationData()?.profilePictureKey]"
                                    [style.transform]="'rotate(' + activeConversationData()?.pictureTransform + 'deg)'"
                                    [alt]="activeConversationData()?.firstName + ' ' + activeConversationData()?.lastName"
                                    loading="lazy">
                                }
                            </div>

                            <div class="tw-absolute -tw-bottom-0.5 -tw-right-0.5 tw-transition-all tw-duration-500 tw-ease-out"
                                [class.tw-scale-100]="activeConversationData()?.isOnline"
                                [class.tw-scale-0]="!activeConversationData()?.isOnline">
                                <div class="tw-relative tw-flex tw-items-center tw-justify-center">
                                    <div
                                        class="tw-relative tw-w-3 tw-h-3 tw-bg-green-500 tw-rounded-full tw-ring-2 tw-ring-white dark:tw-ring-gray-900 tw-shadow-sm">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tw-flex-1 tw-min-w-0">
                            <div class="tw-flex tw-items-center tw-gap-2">
                                <h2
                                    class="tw-text-lg tw-font-semibold tw-text-gray-900 dark:tw-text-gray-100 tw-truncate tw-mb-0.5 tw-transition-colors tw-duration-200">
                                    {{ activeConversationData()?.firstName }} {{ activeConversationData()?.lastName }}
                                </h2>
                            </div>

                            <div class="tw-relative tw-h-5 tw-overflow-hidden">
                                @if (activeConversationData()?.isTyping) {
                                <div
                                    class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-gap-2 tw-animate-in tw-slide-in-from-bottom-2 tw-fade-in tw-duration-300">
                                    <div class="tw-flex tw-items-baseline tw-gap-1 tw-px-2.5 tw-py-1">
                                        <div class="tw-text-xs tw-text-blue-600 dark:tw-text-blue-400 tw-font-medium">
                                            Typing
                                        </div>

                                        <div class="tw-flex tw-gap-0.5">
                                            <div
                                                class="tw-w-[5px] tw-h-[5px] tw-bg-blue-500 tw-rounded-full tw-animate-bounce [animation-delay:-0.3s]">
                                            </div>
                                            <div
                                                class="tw-w-[5px] tw-h-[5px] tw-bg-blue-500 tw-rounded-full tw-animate-bounce [animation-delay:-0.3s]">
                                            </div>
                                            <div
                                                class="tw-w-[5px] tw-h-[5px] tw-bg-blue-500 tw-rounded-full tw-animate-bounce">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                } @else {
                                <div
                                    class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-animate-in tw-slide-in-from-top-2 tw-fade-in tw-duration-300">
                                    @if (activeConversationData()?.isOnline) {
                                    <div class="tw-flex tw-items-center tw-gap-2 tw-text-xs">
                                        <div
                                            class="tw-flex tw-items-center tw-gap-1.5 tw-px-2 tw-py-0.5 tw-text-green-700 dark:tw-text-green-400">
                                            <span class="tw-font-medium">Online</span>
                                        </div>
                                    </div>
                                    } @else if (activeConversationData()?.lastSeen &&
                                    !activeConversationData()?.isOnline) {
                                    <div class="tw-flex tw-items-center tw-gap-2 tw-text-xs">
                                        <div
                                            class="tw-flex tw-items-center tw-gap-1.5 tw-px-2 tw-py-0.5 tw-text-gray-600 dark:tw-text-gray-400">
                                            <div class="tw-w-1.5 tw-h-1.5 tw-bg-gray-400 tw-rounded-full tw-opacity-60">
                                            </div>
                                            <span>Last Seen {{ (activeConversationData()?.lastSeen!) | timeAgo}}</span>
                                        </div>
                                    </div>
                                    } @else {
                                    <div class="tw-flex tw-items-center tw-gap-2 tw-text-xs">
                                        <div
                                            class="tw-flex tw-items-center tw-gap-1.5 tw-px-2 tw-py-0.5 tw-text-gray-500 dark:tw-text-gray-500">
                                            <span class="tw-font-medium">Offline</span>
                                        </div>
                                    </div>
                                    }
                                </div>
                                }
                            </div>
                        </div>
                    </div>

                    <div class="tw-flex tw-items-center tw-gap-1 tw-ml-4">
                        <button (click)="showChatSearch.set(!showChatSearch())"
                            [class]="showChatSearch() ? 
            'tw-group tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-rounded-xl tw-bg-blue-100 dark:tw-bg-blue-900/30 tw-text-blue-600 dark:tw-text-blue-400 tw-transition-all tw-duration-200 hover:tw-scale-105 tw-active:scale-95 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500/30 dark:focus:tw-ring-blue-400/30' :
            'tw-group tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-rounded-xl tw-text-gray-500 dark:tw-text-gray-400 hover:tw-text-gray-700 dark:hover:tw-text-gray-300 hover:tw-bg-gray-100/80 dark:hover:tw-bg-gray-800/80 tw-transition-all tw-duration-200 hover:tw-scale-105 tw-active:scale-95 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500/30 dark:focus:tw-ring-blue-400/30'">
                            <ng-icon name="heroMagnifyingGlass" size="18" [class]="showChatSearch() ? 
              'tw-scale-110 tw-transition-transform tw-duration-200' :
              'group-hover:tw-scale-110 tw-transition-transform tw-duration-200'"></ng-icon>
                        </button>
                    </div>
                </div>
            </div>

            <div
                class="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-h-px tw-bg-gradient-to-r tw-from-transparent tw-via-gray-200/80 tw-to-transparent dark:tw-via-gray-700/80 tw-transition-opacity tw-duration-300">
            </div>
        </header>

        @if (showChatSearch()) {
        <div
            class="tw-px-4 tw-py-2 tw-bg-white/95 dark:tw-bg-slate-900/95 tw-border-b tw-border-slate-200/70 dark:tw-border-slate-700/70 tw-backdrop-blur-sm">
            <div
                class="tw-flex tw-items-center tw-space-x-2 tw-bg-gray-100 dark:tw-bg-gray-800 tw-rounded-full tw-px-4 tw-py-2">
                <ng-icon name="heroMagnifyingGlass" size="16" class="tw-text-gray-500 dark:tw-text-gray-400"></ng-icon>

                <input type="text" [ngModel]="chatSearchQuery()" (ngModelChange)="chatSearchQuery.set($event)"
                    (input)="searchInChat()" placeholder="Search in conversation..."
                    class="tw-flex-1 tw-bg-transparent tw-border-0 focus:tw-outline-none tw-text-sm tw-text-gray-900 dark:tw-text-gray-100 tw-placeholder-gray-500 dark:tw-placeholder-gray-400">
                @if (searchResults().length > 0) {
                <div class="tw-flex tw-items-center tw-space-x-2 tw-text-xs tw-text-gray-500 dark:tw-text-gray-400">
                    <span class="tw-whitespace-nowrap">{{ currentSearchIndex() + 1 }} of {{ searchResults().length
                        }}</span>

                    <button (click)="navigateSearchResults('prev')"
                        class="tw-p-1 hover:tw-bg-gray-200 dark:hover:tw-bg-gray-700 tw-rounded">
                        <ng-icon name="heroChevronUp" size="14"></ng-icon>
                    </button>

                    <button (click)="navigateSearchResults('next')"
                        class="tw-p-1 hover:tw-bg-gray-200 dark:hover:tw-bg-gray-700 tw-rounded">
                        <ng-icon name="heroChevronDown" size="14"></ng-icon>
                    </button>
                </div>
                }

                <button (click)="clearChatSearch()"
                    class="tw-p-1 hover:tw-bg-gray-200 dark:hover:tw-bg-gray-700 tw-rounded tw-flex">
                    <ng-icon name="heroXMark" size="16"></ng-icon>
                </button>
            </div>
        </div>
        }
        }

        @if (isUploading()) {
        <div
            class="tw-sticky tw-top-0 tw-z-50 tw-bg-blue-50 dark:tw-bg-blue-900/20 tw-border-b tw-border-blue-200 dark:tw-border-blue-800">
            <div class="tw-px-4 tw-py-3">
                <div class="tw-space-y-2">
                    @for (progress of uploadProgress() | keyvalue; track progress.key) {
                    <div class="tw-flex tw-items-center tw-space-x-3">
                        <div class="tw-flex-1">
                            <div class="tw-w-full tw-bg-blue-200 dark:tw-bg-blue-800 tw-rounded-full tw-h-2">
                                <div class="tw-bg-blue-500 dark:tw-bg-blue-400 tw-h-2 tw-rounded-full tw-transition-all tw-duration-300"
                                    [style.width.%]="progress.value"></div>
                            </div>
                        </div>
                        <span class="tw-text-xs tw-font-medium tw-text-blue-600 dark:tw-text-blue-400 tw-min-w-12">
                            {{ progress.value.toFixed(0) }}%
                        </span>
                    </div>
                    }
                </div>
            </div>
        </div>
        }

        @if (activeConversation()) {
        <div class="tw-flex-1 tw-overflow-y-auto tw-p-6 tw-messages-container" (scroll)="onMessagesScroll($event)">
            @if (isLoading() && messages().length == 0) {
            <app-chat-skeleton></app-chat-skeleton>
            } @else {
            <div class="tw-space-y-6">

                @for (message of messages(); track message._id) {
                @if (shouldShowDateSeparator(messages(), $index)) {
                <div class="tw-flex tw-items-center tw-justify-center tw-my-8">
                    <div class="tw-relative tw-flex tw-items-center tw-w-full tw-max-w-xs">
                        <div
                            class="tw-flex-1 tw-h-px tw-bg-gradient-to-r tw-from-transparent tw-via-slate-300/60 tw-to-transparent dark:tw-via-slate-600/40">
                        </div>

                        <div class="tw-px-4 tw-py-2 tw-mx-4 tw-text-xs tw-font-semibold tw-tracking-wider tw-uppercase 
            tw-text-slate-600/80 dark:tw-text-slate-400/80 tw-bg-white/80 dark:tw-bg-slate-800/80 
            tw-backdrop-blur-sm tw-border tw-border-slate-200/50 dark:tw-border-slate-700/50 
            tw-rounded-full tw-shadow-sm">
                            {{ formatDateLabel(message?.createdAt!) }}
                        </div>

                        <div
                            class="tw-flex-1 tw-h-px tw-bg-gradient-to-r tw-from-transparent tw-via-slate-300/60 tw-to-transparent dark:tw-via-slate-600/40">
                        </div>
                    </div>
                </div>
                }

                <div class="tw-group tw-relative tw-p-3 tw-flex tw-animate-in tw-fade-in tw-slide-in-from-bottom-2 tw-duration-300"
                    [attr.data-message-id]="message._id" [id]="'message-' + message._id"
                    [ngClass]="{ 'tw-justify-end': message?.userId==loggedUser?.id }">

                    <div class="tw-flex tw-flex-col tw-max-w-[80%] lg:tw-max-w-[70%] tw-gap-1"
                        [ngClass]="{ 'tw-items-end': message?.userId==loggedUser?.id, 'tw-items-start':  message?.userId!=loggedUser?.id }">

                        @if ( message?.userId==loggedUser?.id) {
                        <div class="tw-relative tw-flex-shrink-0">
                            <div class="tw-flex tw-items-center tw-justify-end tw-gap-x-3 tw-pt-1">
                                <div class="tw-flex tw-items-center tw-gap-x-2">
                                    <span class="tw-text-sm tw-font-semibold tw-text-gray-900 dark:tw-text-gray-100">
                                        You
                                    </span>
                                </div>
                            </div>
                        </div>

                        } @else {
                        <div class="tw-relative tw-flex-shrink-0">
                            <div class="tw-flex tw-items-center tw-gap-x-2 tw-pt-1">
                                @if (message?.senderAvatar?.includes('Avatar')) {
                                <div
                                    class="tw-w-9 tw-h-9 tw-rounded-full tw-object-cover tw-ring-2 tw-ring-white/70 dark:tw-ring-slate-700/70 tw-shadow-lg tw-transition-all tw-duration-300 hover:tw-scale-105">
                                    <app-user-avatar [pictureKey]="message?.senderAvatar || ''" [pictureTransform]="0"
                                        [pictureID]="(message?._id)?.toString() || ''">
                                    </app-user-avatar>
                                </div>
                                } @else {
                                <img class="tw-w-9 tw-h-9 tw-rounded-full tw-object-cover tw-ring-2 tw-ring-white/70 dark:tw-ring-slate-700/70 tw-shadow-lg tw-transition-all tw-duration-300 hover:tw-scale-105"
                                    [src]="[profileApiUrl + message?.senderAvatar]" [alt]="message?.sender"
                                    loading="lazy">
                                }
                                <p class="tw-mb-0">
                                    <span class="tw-font-bold">{{ message.sender }}</span>
                                </p>
                            </div>
                        </div>
                        }

                        <div class="tw-flex tw-flex-col tw-relative tw-group/message">
                            @if (message.replyToId && !message.isDeleted) {
                            <div class="tw-mb-2 tw-p-2 tw-bg-gray-100 dark:tw-bg-gray-800 tw-rounded-lg tw-border-l-2 tw-border-gray-300 dark:tw-border-gray-600 tw-max-w-md tw-cursor-pointer tw-transition-colors hover:tw-bg-gray-50 dark:hover:tw-bg-gray-750"
                                (click)="scrollToRepliedMessage(message.replyToId)">
                                <div class="tw-flex tw-items-center tw-gap-1 tw-mb-1">
                                    <ng-icon name="heroArrowUturnLeft" size="12" class="tw-text-gray-500"></ng-icon>
                                    <span class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-400">Reply to {{
                                        message.replyToSender }}</span>
                                </div>
                                <p class="tw-text-xs tw-text-gray-600 dark:tw-text-gray-300 tw-line-clamp-2 tw-mb-0">{{
                                    message.replyToContent }}</p>
                                <div
                                    class="tw-absolute tw-right-2 tw-top-2 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity">
                                    <ng-icon name="heroArrowUpRight" size="12" class="tw-text-blue-500"></ng-icon>
                                </div>
                            </div>
                            }

                            <div class="tw-relative tw-flex tw-items-end tw-gap-2"
                                [ngClass]="{ 'tw-flex-row-reverse': message?.userId==loggedUser?.id, 'tw-flex-row':  message?.userId!=loggedUser?.id }">

                                <div *ngIf="message.type === 'text'" class="tw-relative tw-group/bubble">
                                    <div class="tw-relative tw-rounded-3xl tw-px-4 tw-py-3 tw-transition-all tw-duration-300 tw-backdrop-blur-lg tw-border tw-shadow-xl tw-max-w-md tw-min-w-[120px]"
                                        [ngClass]="{'tw-bg-white/95 dark:tw-bg-slate-800/95 tw-border-slate-200/60 dark:tw-border-slate-700/60 tw-text-slate-800 dark:tw-text-slate-200 tw-shadow-slate-200/50 dark:tw-shadow-slate-900/50 tw-rounded-tl-xl': message?.userId!=loggedUser?.id && !message?.isDeleted,'tw-bg-blue-500/90 dark:tw-bg-blue-600/90 tw-border-blue-400/20 dark:tw-border-blue-500/20 tw-text-white tw-shadow-blue-400/30 dark:tw-shadow-blue-600/50 tw-rounded-tr-xl': message?.userId==loggedUser?.id && !message?.isDeleted, 'tw-bg-gray-100 dark:tw-bg-gray-800/60 tw-border-gray-200/40 dark:tw-border-gray-700/40 tw-text-gray-500 dark:tw-text-gray-400 tw-shadow-gray-200/30 dark:tw-shadow-gray-900/30 tw-rounded-tl-xl tw-opacity-70':message?.isDeleted}">

                                        <div [class.tw-mb-2]="!message.isDeleted">
                                            <p *ngIf="!message?.isDeleted"
                                                class="tw-leading-relaxed tw-text-[15px] tw-break-words tw-mb-0 tw-whitespace-pre-wrap"
                                                [ngClass]="{'tw-text-slate-800 dark:tw-text-slate-200': message?.userId!=loggedUser?.id, 'tw-text-white': message?.userId==loggedUser?.id  }"
                                                [innerHTML]="message.content | linkify">
                                            </p>

                                            <p *ngIf="message?.isDeleted"
                                                class="tw-leading-relaxed tw-text-[15px] tw-break-words tw-mb-0 tw-italic tw-flex tw-items-center tw-gap-2">
                                                <ng-icon name="heroNoSymbol" size="14" class="tw-opacity-60"></ng-icon>
                                                <span class="tw-opacity-75">This message was deleted</span>
                                                <time [dateTime]="message.deletedAt"
                                                    [title]="message?.isDeleted ? 'Deleted on ' + formatFullTime(message.deletedAt!) : formatFullTime(message.deletedAt!)"
                                                    class="tw-text-[10px] tw-font-medium tw-tabular-nums tw-tracking-wide tw-transition-colors tw-flex-shrink-0"
                                                    [ngClass]="{ 'tw-text-slate-500 dark:tw-text-slate-400 hover:tw-text-slate-700 dark:hover:tw-text-slate-300': message?.userId!=loggedUser?.id && !message?.isDeleted, 'tw-text-blue-100 dark:tw-text-blue-200 hover:tw-text-white dark:hover:tw-text-blue-100': message?.userId==loggedUser?.id && !message?.isDeleted, 'tw-text-gray-400 dark:tw-text-gray-500': message?.isDeleted  }">
                                                    {{ formatTime(message.deletedAt!) }}
                                                </time>
                                            </p>
                                        </div>

                                        @if (!message?.isDeleted) {
                                        <div class="tw-flex tw-items-center tw-justify-end tw-gap-2 tw-mt-2">
                                            <time [dateTime]="message.createdAt"
                                                [title]="message?.isDeleted ? 'Deleted on ' + formatFullTime((message.updatedAt!?message.updatedAt!:message.createdAt!)) : formatFullTime((message.updatedAt!?message.updatedAt!:message.createdAt!))"
                                                class="tw-text-[10px] tw-font-medium tw-tabular-nums tw-tracking-wide tw-transition-colors tw-flex-shrink-0"
                                                [ngClass]="{ 'tw-text-slate-500 dark:tw-text-slate-400 hover:tw-text-slate-700 dark:hover:tw-text-slate-300': message?.userId!=loggedUser?.id && !message?.isDeleted, 'tw-text-blue-100 dark:tw-text-blue-200 hover:tw-text-white dark:hover:tw-text-blue-100': message?.userId==loggedUser?.id && !message?.isDeleted, 'tw-text-gray-400 dark:tw-text-gray-500': message?.isDeleted  }">
                                                {{
                                                formatTime((message.updatedAt!?message.updatedAt!:message.createdAt!))
                                                }}
                                            </time>
                                            <small *ngIf="message.isEdited"
                                                class="tw-text-[10px] tw-font-medium tw-tabular-nums tw-tracking-wide tw-transition-colors tw-flex-shrink-0"
                                                [ngClass]="{ 'tw-text-slate-500 dark:tw-text-slate-400 hover:tw-text-slate-700 dark:hover:tw-text-slate-300': message?.userId!=loggedUser?.id && !message?.isDeleted, 'tw-text-blue-100 dark:tw-text-blue-200 hover:tw-text-white dark:hover:tw-text-blue-100': message?.userId==loggedUser?.id && !message?.isDeleted, 'tw-text-gray-400 dark:tw-text-gray-500': message?.isDeleted  }">(edited)</small>

                                            <div *ngIf="message?.userId==loggedUser?.id" class="tw-flex tw-items-center"
                                                [attr.aria-label]="getReadStatusLabel(message.isRead)"
                                                [attr.title]="getReadStatusLabel(message.isRead)" role="img">
                                                <ng-icon [name]="message.isRead ? 'tablerChecks' : 'tablerCheck'"
                                                    size="14" class="tw-transition-all tw-duration-200 tw-ease-in-out"
                                                    [ngClass]="{ 'tw-text-white/90 tw-opacity-100': message.isRead, 'tw-text-white/60 tw-opacity-70': !message.isRead }"
                                                    [attr.aria-hidden]="true">
                                                </ng-icon>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                    @if (!message?.isDeleted) {
                                    <div class="tw-absolute  group-hover/bubble:tw-opacity-100 tw-transition-all tw-duration-200 tw-ease-in-out tw-z-20 -tw-bottom-2 tw-pointer-events-none group-hover/bubble:tw-pointer-events-auto"
                                        [ngClass]="{ 'tw-right-0 tw-translate-x-3 -tw-translate-y-1': message?.userId==loggedUser?.id,  'tw-left-0 -tw-translate-x-3 -tw-translate-y-1':  message?.userId!=loggedUser?.id }">
                                        <button type="button"
                                            (contextmenu)="onMessageContextMenu($event, message, messageMenuTrigger)"
                                            (click)="onMessageContextMenu($event, message, messageMenuTrigger)"
                                            [matMenuTriggerFor]="messageContextMenu"
                                            #messageMenuTrigger="matMenuTrigger"
                                            [attr.aria-label]="'Message options for ' + (message?.userId==loggedUser?.id ? 'your message' : 'received message')"
                                            class="tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-shadow-lg hover:tw-shadow-xl tw-transition-all tw-duration-200 hover:tw-scale-110 tw-backdrop-blur-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2"
                                            [ngClass]="{'tw-bg-white dark:tw-bg-slate-700 tw-border-slate-200 dark:tw-border-slate-600 tw-text-slate-600 dark:tw-text-slate-300 hover:tw-bg-slate-50 dark:hover:tw-bg-slate-600 focus:tw-ring-slate-500':  message?.userId!=loggedUser?.id,'tw-bg-white dark:tw-bg-slate-700 tw-border-blue-200 dark:tw-border-blue-500 tw-text-blue-600 dark:tw-text-blue-400 hover:tw-bg-blue-50 dark:hover:tw-bg-slate-600 focus:tw-ring-blue-500': message?.userId==loggedUser?.id}">
                                            <ng-icon name="heroEllipsisHorizontal" size="16" [attr.aria-hidden]="true">
                                            </ng-icon>
                                        </button>
                                    </div>
                                    }
                                </div>

                                <!-- Image Messages with On-Demand Loading -->
                                <div *ngIf="message.type === 'image'" class="tw-max-w-sm tw-relative tw-group-bubble">

                                    <div *ngIf="message?.isDeleted"
                                        class="tw-relative tw-overflow-hidden tw-rounded-2xl tw-shadow-sm tw-bg-gray-100 dark:tw-bg-gray-800 tw-border-2 tw-border-dashed tw-border-gray-300 dark:tw-border-gray-600 tw-opacity-60">
                                        <div
                                            class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-8 tw-py-6 tw-text-center">
                                            <ng-icon name="heroPhoto" size="32"
                                                class="tw-text-gray-400 dark:tw-text-gray-500 tw-mb-2"></ng-icon>
                                            <p
                                                class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-400 tw-italic tw-mb-2">
                                                This image was deleted</p>
                                            <time [dateTime]="message.deletedAt"
                                                [title]="'Deleted on ' + formatFullTime(message.deletedAt!)"
                                                class="tw-text-10px tw-font-medium tw-text-gray-400 dark:tw-text-gray-500">
                                                {{formatTime(message.deletedAt!)}}
                                            </time>
                                        </div>
                                    </div>

                                    <!-- NORMAL STATE (Not Deleted) -->
                                    <div *ngIf="!message?.isDeleted"
                                        class="tw-relative tw-overflow-hidden tw-rounded-2xl tw-shadow-lg hover:tw-shadow-xl tw-transition-shadow tw-duration-300">

                                        <!-- Load Image Button (When file not loaded) -->
                                        <div *ngIf="message.fileId && !message.fileUrl && !message.isFileLoading && !message.fileLoadError"
                                            class="tw-w-full tw-h-48 tw-bg-gradient-to-br tw-from-gray-50 tw-to-gray-100 dark:tw-from-gray-800 dark:tw-to-gray-900 tw-flex tw-flex-col tw-items-center tw-justify-center tw-border-2 tw-border-dashed tw-border-gray-300 dark:tw-border-gray-600 tw-relative tw-group">

                                            <div class="tw-flex tw-flex-col tw-items-center tw-gap-3">
                                                <div
                                                    class="tw-w-16 tw-h-16 tw-bg-blue-100 dark:tw-bg-blue-900/30 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                                                    <ng-icon name="heroPhoto" size="32"
                                                        class="tw-text-blue-600 dark:tw-text-blue-400"></ng-icon>
                                                </div>

                                                <div class="tw-text-center">
                                                    <p
                                                        class="tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-gray-100 tw-mb-1">
                                                        {{message.fileName || 'Image'}}
                                                    </p>
                                                    <p *ngIf="message.fileSize"
                                                        class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-400 tw-mb-3">
                                                        {{formatFileSize(message.fileSize)}}
                                                    </p>
                                                </div>

                                                <button (click)="loadImageOnDemand(message)"
                                                    class="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-bg-blue-600 hover:tw-bg-blue-700 tw-text-white tw-rounded-full tw-transition-all tw-duration-200 hover:tw-scale-105 tw-shadow-lg">
                                                    <ng-icon name="heroArrowDownTray" size="16"></ng-icon>
                                                    <span class="tw-text-sm tw-font-medium">Load Image</span>
                                                </button>
                                            </div>

                                            <!-- ACTION BUTTON for Load State -->
                                            <div
                                                class="tw-absolute tw-top-2 tw-right-2 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-200">
                                                <button type="button"
                                                    (contextmenu)="onMessageContextMenu($event, message, imageMenuTrigger)"
                                                    (click)="onMessageContextMenu($event, message, imageMenuTrigger)"
                                                    [matMenuTriggerFor]="messageContextMenu"
                                                    #imageMenuTrigger="matMenuTrigger"
                                                    class="tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-white/80 dark:tw-bg-gray-800/80 tw-backdrop-blur-sm tw-text-gray-600 dark:tw-text-gray-300 hover:tw-bg-white dark:hover:tw-bg-gray-700 tw-transition-all tw-duration-200 hover:tw-scale-110 tw-shadow-lg focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500/30">
                                                    <ng-icon name="heroEllipsisHorizontal" size="16"></ng-icon>
                                                </button>
                                            </div>
                                        </div>

                                        <!-- Loading state -->
                                        <div *ngIf="message.isFileLoading"
                                            class="tw-w-full tw-h-48 tw-bg-gray-100 dark:tw-bg-gray-800 tw-flex tw-flex-col tw-items-center tw-justify-center">
                                            <div
                                                class="tw-animate-spin tw-rounded-full tw-h-8 tw-w-8 tw-border-2 tw-border-blue-500 tw-border-t-transparent tw-mb-3">
                                            </div>
                                            <p class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-400">Loading
                                                image...</p>
                                        </div>

                                        <!-- Error state -->
                                        <div *ngIf="message.fileLoadError"
                                            class="tw-w-full tw-h-48 tw-bg-red-50 dark:tw-bg-red-900/20 tw-flex tw-flex-col tw-items-center tw-justify-center tw-border-2 tw-border-dashed tw-border-red-300 dark:tw-border-red-700 tw-relative tw-group">
                                            <ng-icon name="heroExclamationTriangle" size="32"
                                                class="tw-text-red-500 tw-mb-2"></ng-icon>
                                            <p class="tw-text-sm tw-text-red-600 dark:tw-text-red-400 tw-mb-3">Failed to
                                                load image</p>
                                            <button (click)="loadImageOnDemand(message)"
                                                class="tw-text-sm tw-text-red-600 dark:tw-text-red-400 hover:tw-text-red-700 dark:hover:tw-text-red-300 tw-underline">
                                                Try Again
                                            </button>

                                            <!-- ACTION BUTTON for Error State -->
                                            <div
                                                class="tw-absolute tw-top-2 tw-right-2 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-200">
                                                <button type="button"
                                                    (contextmenu)="onMessageContextMenu($event, message, imageMenuTrigger)"
                                                    (click)="onMessageContextMenu($event, message, imageMenuTrigger)"
                                                    [matMenuTriggerFor]="messageContextMenu"
                                                    #imageMenuTrigger="matMenuTrigger"
                                                    class="tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-white/80 dark:tw-bg-gray-800/80 tw-backdrop-blur-sm tw-text-gray-600 dark:tw-text-gray-300 hover:tw-bg-white dark:hover:tw-bg-gray-700 tw-transition-all tw-duration-200 hover:tw-scale-110 tw-shadow-lg focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-red-500/30">
                                                    <ng-icon name="heroEllipsisHorizontal" size="16"></ng-icon>
                                                </button>
                                            </div>
                                        </div>

                                        <!-- Loaded image -->
                                        <div *ngIf="message.fileUrl" class="tw-relative tw-group">
                                            <img [src]="message.fileUrl" [alt]="message.fileName || 'Image'"
                                                class="tw-w-full tw-max-w-sm tw-max-h-96 tw-object-cover tw-cursor-pointer tw-transition-transform tw-duration-300 hover:tw-scale-105"
                                                (error)="message.imageLoadError = true">

                                            <!-- Gradient overlay on hover -->
                                            <div
                                                class="tw-absolute tw-inset-0 tw-bg-gradient-to-t tw-from-black/20 tw-to-transparent tw-opacity-0 hover:tw-opacity-100 tw-transition-opacity tw-duration-300">
                                            </div>

                                            <!-- ACTION BUTTON for Loaded Image -->
                                            <div
                                                class="tw-absolute tw-top-2 tw-right-2 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-200">
                                                <button type="button"
                                                    (contextmenu)="onMessageContextMenu($event, message, imageMenuTrigger)"
                                                    (click)="onMessageContextMenu($event, message, imageMenuTrigger)"
                                                    [matMenuTriggerFor]="messageContextMenu"
                                                    #imageMenuTrigger="matMenuTrigger"
                                                    class="tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-black/30 hover:tw-bg-black/50 tw-backdrop-blur-sm tw-text-white tw-transition-all tw-duration-200 hover:tw-scale-110 tw-shadow-lg focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-white/50">
                                                    <ng-icon name="heroEllipsisHorizontal" size="16"></ng-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Video Messages with On-Demand Loading -->
                                <div *ngIf="message.type === 'video'" class="tw-max-w-sm tw-relative tw-group-bubble">

                                    <!-- DELETED STATE -->
                                    <div *ngIf="message?.isDeleted"
                                        class="tw-relative tw-overflow-hidden tw-rounded-2xl tw-shadow-sm tw-bg-gray-100 dark:tw-bg-gray-800 tw-border-2 tw-border-dashed tw-border-gray-300 dark:tw-border-gray-600 tw-opacity-60">
                                        <div
                                            class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-8 tw-py-6 tw-text-center">
                                            <ng-icon name="heroVideoCamera" size="32"
                                                class="tw-text-gray-400 dark:tw-text-gray-500 tw-mb-2"></ng-icon>
                                            <p
                                                class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-400 tw-italic tw-mb-2">
                                                This video was deleted</p>
                                            <time [dateTime]="message.deletedAt"
                                                [title]="'Deleted on ' + formatFullTime(message.deletedAt!)"
                                                class="tw-text-10px tw-font-medium tw-text-gray-400 dark:tw-text-gray-500">
                                                {{formatTime(message.deletedAt!)}}
                                            </time>
                                        </div>
                                    </div>

                                    <!-- NORMAL STATE (Not Deleted) -->
                                    <div *ngIf="!message?.isDeleted"
                                        class="tw-relative tw-overflow-hidden tw-rounded-2xl tw-shadow-lg hover:tw-shadow-xl tw-transition-shadow tw-duration-300">

                                        <!-- Load video button -->
                                        <div *ngIf="message.fileId && !message.fileUrl && !message.isFileLoading"
                                            class="tw-w-full tw-h-48 tw-bg-gradient-to-br tw-from-purple-50 tw-to-purple-100 dark:tw-from-purple-900/30 dark:tw-to-purple-800/30 tw-flex tw-flex-col tw-items-center tw-justify-center tw-relative tw-group">

                                            <div class="tw-flex tw-flex-col tw-items-center tw-gap-3">
                                                <div
                                                    class="tw-w-16 tw-h-16 tw-bg-purple-100 dark:tw-bg-purple-900/50 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                                                    <ng-icon name="heroVideoCamera" size="32"
                                                        class="tw-text-purple-600 dark:tw-text-purple-400"></ng-icon>
                                                </div>

                                                <div class="tw-text-center">
                                                    <p
                                                        class="tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-gray-100 tw-mb-1">
                                                        {{message.fileName || 'Video'}}
                                                    </p>
                                                    <p *ngIf="message.fileSize"
                                                        class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-400 tw-mb-3">
                                                        {{formatFileSize(message.fileSize)}}
                                                    </p>
                                                </div>

                                                <button (click)="loadVideoOnDemand(message)"
                                                    class="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-bg-purple-600 hover:tw-bg-purple-700 tw-text-white tw-rounded-full tw-transition-all tw-duration-200 hover:tw-scale-105 tw-shadow-lg">
                                                    <ng-icon name="heroPlay" size="16"></ng-icon>
                                                    <span class="tw-text-sm tw-font-medium">Load Video</span>
                                                </button>
                                            </div>

                                            <!-- ACTION BUTTON -->
                                            <div
                                                class="tw-absolute tw-top-2 tw-right-2 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-200">
                                                <button type="button"
                                                    (contextmenu)="onMessageContextMenu($event, message, videoMenuTrigger)"
                                                    (click)="onMessageContextMenu($event, message, videoMenuTrigger)"
                                                    [matMenuTriggerFor]="messageContextMenu"
                                                    #videoMenuTrigger="matMenuTrigger"
                                                    class="tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-white/80 dark:tw-bg-gray-800/80 tw-backdrop-blur-sm tw-text-gray-600 dark:tw-text-gray-300 hover:tw-bg-white dark:hover:tw-bg-gray-700 tw-transition-all tw-duration-200 hover:tw-scale-110 tw-shadow-lg focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-purple-500/30">
                                                    <ng-icon name="heroEllipsisHorizontal" size="16"></ng-icon>
                                                </button>
                                            </div>
                                        </div>

                                        <!-- Video loading state -->
                                        <div *ngIf="message.isFileLoading"
                                            class="tw-w-full tw-h-48 tw-bg-gray-100 dark:tw-bg-gray-800 tw-flex tw-items-center tw-justify-center">
                                            <div
                                                class="tw-animate-spin tw-rounded-full tw-h-8 tw-w-8 tw-border-2 tw-border-purple-500 tw-border-t-transparent">
                                            </div>
                                        </div>

                                        <!-- Loaded video -->
                                        <div *ngIf="message.fileUrl" class="tw-relative tw-group">
                                            <video class="tw-w-full tw-max-w-sm tw-max-h-96 tw-object-cover tw-bg-black"
                                                controls [poster]="message.thumbnailUrl" preload="metadata">
                                                <source [src]="message.fileUrl" type="video/mp4">
                                                Your browser does not support the video tag.
                                            </video>

                                            <!-- ACTION BUTTON for Loaded Video -->
                                            <div
                                                class="tw-absolute tw-top-2 tw-right-2 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-200">
                                                <button type="button"
                                                    (contextmenu)="onMessageContextMenu($event, message, videoMenuTrigger)"
                                                    (click)="onMessageContextMenu($event, message, videoMenuTrigger)"
                                                    [matMenuTriggerFor]="messageContextMenu"
                                                    #videoMenuTrigger="matMenuTrigger"
                                                    class="tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-black/30 hover:tw-bg-black/50 tw-backdrop-blur-sm tw-text-white tw-transition-all tw-duration-200 hover:tw-scale-110 tw-shadow-lg focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-white/50">
                                                    <ng-icon name="heroEllipsisHorizontal" size="16"></ng-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Audio Messages with On-Demand Loading -->
                                <div *ngIf="message.type === 'audio'" class="tw-relative tw-group-bubble tw-max-w-sm">

                                    <!-- DELETED STATE -->
                                    <div *ngIf="message?.isDeleted"
                                        class="tw-flex tw-items-center tw-gap-3 tw-p-4 tw-bg-gray-50/60 dark:tw-bg-gray-800/60 tw-border tw-border-dashed tw-border-gray-300 dark:tw-border-gray-600 tw-rounded-2xl tw-opacity-60">
                                        <div class="tw-flex-shrink-0">
                                            <div
                                                class="tw-w-12 tw-h-12 tw-bg-gray-100 dark:tw-bg-gray-700 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                                                <ng-icon name="heroMusicalNote" size="24"
                                                    class="tw-text-gray-400 dark:tw-text-gray-500"></ng-icon>
                                            </div>
                                        </div>
                                        <div class="tw-flex-1 tw-min-w-0">
                                            <p
                                                class="tw-font-medium tw-text-sm tw-text-gray-500 dark:tw-text-gray-400 tw-italic tw-mb-1">
                                                This audio was deleted</p>
                                            <time [dateTime]="message.deletedAt"
                                                [title]="'Deleted on ' + formatFullTime(message.deletedAt!)"
                                                class="tw-text-10px tw-font-medium tw-text-gray-400 dark:tw-text-gray-500">
                                                {{formatTime(message.deletedAt!)}}
                                            </time>
                                        </div>
                                    </div>

                                    <!-- NORMAL STATE (Not Deleted) -->
                                    <div *ngIf="!message?.isDeleted"
                                        class="tw-bg-gray-50 dark:tw-bg-gray-800 tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-rounded-2xl tw-p-4 tw-relative tw-group">

                                        <!-- Load audio button -->
                                        <div *ngIf="message.fileId && !message.fileUrl && !message.isFileLoading"
                                            class="tw-flex tw-items-center tw-gap-3">
                                            <button (click)="loadAudioOnDemand(message)"
                                                class="tw-flex-shrink-0 tw-w-12 tw-h-12 tw-bg-green-100 dark:tw-bg-green-900/30 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-transition-all tw-duration-200 hover:tw-scale-105 hover:tw-bg-green-200 dark:hover:tw-bg-green-900/50">
                                                <ng-icon name="heroArrowDownTray" size="20"
                                                    class="tw-text-green-600 dark:tw-text-green-400"></ng-icon>
                                            </button>

                                            <div class="tw-flex-1 tw-min-w-0">
                                                <p
                                                    class="tw-font-medium tw-text-sm tw-text-gray-900 dark:tw-text-gray-100 tw-truncate tw-mb-1">
                                                    {{message.fileName || 'Audio message'}}
                                                </p>
                                                <p *ngIf="message.fileSize"
                                                    class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-400">
                                                    {{formatFileSize(message.fileSize)}} • Tap to load
                                                </p>
                                            </div>
                                        </div>

                                        <!-- Audio loading state -->
                                        <div *ngIf="message.isFileLoading" class="tw-flex tw-items-center tw-gap-3">
                                            <div
                                                class="tw-flex-shrink-0 tw-w-12 tw-h-12 tw-bg-green-100 dark:tw-bg-green-900/30 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                                                <div
                                                    class="tw-animate-spin tw-rounded-full tw-h-5 tw-w-5 tw-border-2 tw-border-green-500 tw-border-t-transparent">
                                                </div>
                                            </div>
                                            <p class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-400">Loading
                                                audio...</p>
                                        </div>

                                        <!-- Loaded audio player -->
                                        <div *ngIf="message.fileUrl" class="tw-space-y-3">
                                            <!-- Your existing audio player template here -->
                                            <div class="tw-flex tw-items-center tw-gap-3">
                                                <button (click)="toggleAudioPlayback(message)"
                                                    [disabled]="message.isLoading"
                                                    class="tw-flex-shrink-0 tw-w-12 tw-h-12 tw-bg-purple-100 dark:tw-bg-purple-900/30 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-transition-all tw-duration-200 hover:tw-scale-105 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed">
                                                    <div *ngIf="message.isLoading"
                                                        class="tw-animate-spin tw-rounded-full tw-h-5 tw-w-5 tw-border-2 tw-border-purple-500 tw-border-t-transparent">
                                                    </div>
                                                    <ng-icon *ngIf="!message.isLoading"
                                                        [name]="message.isPlaying ? 'heroPause' : 'heroPlay'" size="20"
                                                        class="tw-text-purple-600 dark:tw-text-purple-400"
                                                        [class.tw-ml-0.5]="!message.isPlaying"></ng-icon>
                                                </button>

                                                <div class="tw-flex-1 tw-min-w-0">
                                                    <audio #audioPlayer [src]="message.fileUrl" preload="metadata"
                                                        (timeupdate)="onAudioTimeUpdate(message, audioPlayer)"
                                                        (loadedmetadata)="onAudioLoaded(message, audioPlayer)"
                                                        (ended)="onAudioEnded(message)"
                                                        (canplay)="onAudioCanPlay(message)"
                                                        (error)="onAudioError(message)" class="tw-hidden"></audio>

                                                    <div class="tw-flex tw-items-center tw-gap-2 tw-mb-2">
                                                        <span
                                                            class="tw-text-xs tw-text-gray-500 tw-tabular-nums tw-min-w-[32px]">{{formatAudioTime(message.currentTime
                                                            || 0)}}</span>
                                                        <div class="tw-flex-1 tw-h-1 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded-full tw-cursor-pointer tw-relative"
                                                            (click)="seekAudio(message, $event)">
                                                            <div class="tw-h-full tw-bg-purple-500 tw-rounded-full tw-transition-all tw-duration-100"
                                                                [style.width.%]="getAudioProgress(message)"></div>
                                                            <div *ngIf="message.isLoading"
                                                                class="tw-absolute tw-inset-0 tw-bg-purple-300/50 tw-rounded-full tw-animate-pulse">
                                                            </div>
                                                        </div>
                                                        <span
                                                            class="tw-text-xs tw-text-gray-500 tw-tabular-nums tw-min-w-[32px]">{{formatAudioTime(message.duration
                                                            || 0)}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- ACTION BUTTON -->
                                        <div
                                            class="tw-absolute tw-top-2 tw-right-2 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-200">
                                            <button type="button"
                                                (contextmenu)="onMessageContextMenu($event, message, audioMenuTrigger)"
                                                (click)="onMessageContextMenu($event, message, audioMenuTrigger)"
                                                [matMenuTriggerFor]="messageContextMenu"
                                                #audioMenuTrigger="matMenuTrigger"
                                                class="tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-white/80 dark:tw-bg-gray-700/80 tw-backdrop-blur-sm tw-text-gray-600 dark:tw-text-gray-300 hover:tw-bg-white dark:hover:tw-bg-gray-700 tw-transition-all tw-duration-200 hover:tw-scale-110 tw-shadow-lg focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-green-500/30">
                                                <ng-icon name="heroEllipsisHorizontal" size="16"></ng-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- File Messages with On-Demand Loading -->
                                <div *ngIf="message.type === 'file'" class="tw-relative tw-group-bubble">

                                    <!-- DELETED STATE -->
                                    <div *ngIf="message?.isDeleted"
                                        class="tw-flex tw-items-center tw-gap-3 tw-p-4 tw-bg-gray-50/60 dark:tw-bg-gray-800/60 tw-border tw-border-dashed tw-border-gray-300 dark:tw-border-gray-600 tw-rounded-2xl tw-max-w-sm tw-opacity-60">
                                        <div class="tw-flex-shrink-0">
                                            <div
                                                class="tw-w-12 tw-h-12 tw-bg-gray-100 dark:tw-bg-gray-700 tw-rounded-xl tw-flex tw-items-center tw-justify-center">
                                                <ng-icon name="heroDocument" size="24"
                                                    class="tw-text-gray-400 dark:tw-text-gray-500"></ng-icon>
                                            </div>
                                        </div>
                                        <div class="tw-flex-1 tw-min-w-0">
                                            <p
                                                class="tw-font-medium tw-text-sm tw-text-gray-500 dark:tw-text-gray-400 tw-italic tw-mb-1">
                                                This file was deleted</p>
                                            <time [dateTime]="message.deletedAt"
                                                [title]="'Deleted on ' + formatFullTime(message.deletedAt!)"
                                                class="tw-text-10px tw-font-medium tw-text-gray-400 dark:tw-text-gray-500">
                                                {{formatTime(message.deletedAt!)}}
                                            </time>
                                        </div>
                                    </div>

                                    <!-- NORMAL STATE (Not Deleted) -->
                                    <div *ngIf="!message?.isDeleted" class="tw-relative tw-group">

                                        <!-- Load file button -->
                                        <div *ngIf="message.fileId && !message.fileUrl && !message.isFileLoading"
                                            class="tw-flex tw-items-center tw-gap-3 tw-p-4 tw-bg-gray-50 dark:tw-bg-gray-800 tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-rounded-2xl tw-max-w-sm hover:tw-bg-gray-100 dark:hover:tw-bg-gray-700 tw-transition-colors tw-duration-200 tw-cursor-pointer"
                                            (click)="loadFileOnDemand(message)">

                                            <div class="tw-flex-shrink-0">
                                                <div
                                                    class="tw-w-12 tw-h-12 tw-bg-blue-100 dark:tw-bg-blue-900/30 tw-rounded-xl tw-flex tw-items-center tw-justify-center">
                                                    <ng-icon [name]="getFileIcon(message)" size="24"
                                                        class="tw-text-blue-600 dark:tw-text-blue-400"></ng-icon>
                                                </div>
                                            </div>

                                            <div class="tw-flex-1 tw-min-w-0">
                                                <p
                                                    class="tw-font-medium tw-text-sm tw-text-gray-900 dark:tw-text-gray-100 tw-truncate tw-mb-1">
                                                    {{message.fileName || 'Unknown file'}}
                                                </p>
                                                <div
                                                    class="tw-flex tw-items-center tw-gap-2 tw-text-xs tw-text-gray-500 dark:tw-text-gray-400">
                                                    <span
                                                        *ngIf="message.fileSize">{{formatFileSize(message.fileSize)}}</span>
                                                    <span class="tw-flex tw-items-center tw-gap-1">
                                                        <ng-icon name="heroArrowDownTray" size="12"></ng-icon>
                                                        Tap to download
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- File loading state -->
                                        <div *ngIf="message.isFileLoading"
                                            class="tw-flex tw-items-center tw-gap-3 tw-p-4 tw-bg-gray-50 dark:tw-bg-gray-800 tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-rounded-2xl tw-max-w-sm">
                                            <div
                                                class="tw-w-12 tw-h-12 tw-bg-blue-100 dark:tw-bg-blue-900/30 tw-rounded-xl tw-flex tw-items-center tw-justify-center">
                                                <div
                                                    class="tw-animate-spin tw-rounded-full tw-h-5 tw-w-5 tw-border-2 tw-border-blue-500 tw-border-t-transparent">
                                                </div>
                                            </div>
                                            <div class="tw-flex-1">
                                                <p class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-400">
                                                    Downloading...</p>
                                            </div>
                                        </div>

                                        <!-- Downloaded file (ready for download) -->
                                        <div *ngIf="message.fileUrl"
                                            class="tw-flex tw-items-center tw-gap-3 tw-p-4 tw-bg-green-50 dark:tw-bg-green-900/20 tw-border tw-border-green-200 dark:tw-border-green-700 tw-rounded-2xl tw-max-w-sm tw-relative tw-group">
                                            <div
                                                class="tw-w-12 tw-h-12 tw-bg-green-100 dark:tw-bg-green-900/30 tw-rounded-xl tw-flex tw-items-center tw-justify-center">
                                                <ng-icon name="heroCheckCircle" size="24"
                                                    class="tw-text-green-600 dark:tw-text-green-400"></ng-icon>
                                            </div>
                                            <div class="tw-flex-1 tw-min-w-0">
                                                <p
                                                    class="tw-font-medium tw-text-sm tw-text-gray-900 dark:tw-text-gray-100 tw-truncate">
                                                    {{message.fileName}}
                                                </p>
                                                <p class="tw-text-xs tw-text-green-600 dark:tw-text-green-400">Ready to
                                                    download</p>
                                            </div>
                                            <a [href]="message.fileUrl" [download]="message.fileName"
                                                class="tw-p-2 tw-bg-green-600 hover:tw-bg-green-700 tw-text-white tw-rounded-lg tw-transition-colors">
                                                <ng-icon name="heroArrowDownTray" size="16"></ng-icon>
                                            </a>
                                        </div>

                                        <!-- ACTION BUTTON -->
                                        <div
                                            class="tw-absolute tw-top-2 tw-right-2 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-200">
                                            <button type="button"
                                                (contextmenu)="onMessageContextMenu($event, message, fileMenuTrigger)"
                                                (click)="onMessageContextMenu($event, message, fileMenuTrigger)"
                                                [matMenuTriggerFor]="messageContextMenu"
                                                #fileMenuTrigger="matMenuTrigger"
                                                class="tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-white/80 dark:tw-bg-gray-700/80 tw-backdrop-blur-sm tw-text-gray-600 dark:tw-text-gray-300 hover:tw-bg-white dark:hover:tw-bg-gray-700 tw-transition-all tw-duration-200 hover:tw-scale-110 tw-shadow-lg focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500/30">
                                                <ng-icon name="heroEllipsisHorizontal" size="16"></ng-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>
            }
        </div>
        }

        @if (replyToMessage()) {
        <div class="tw-px-4 tw-pb-2">
            <div
                class="tw-flex tw-items-center tw-justify-between tw-p-3 tw-bg-blue-50 dark:tw-bg-blue-900/20 tw-border-l-2 tw-rounded-lg tw-border-blue-500 tw-rounded-r-lg">
                <div class="tw-flex-1 tw-min-w-0">
                    <div class="tw-flex tw-items-center tw-gap-2 tw-mb-1">
                        <ng-icon name="heroArrowUturnLeft" size="14"
                            class="tw-text-blue-600 dark:tw-text-blue-400"></ng-icon>
                        <span class="tw-text-xs tw-font-medium tw-text-blue-600 dark:tw-text-blue-400">
                            Replying to {{ replyToMessage()!.sender }}
                        </span>
                    </div>
                    <p class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-300 tw-mb-0 tw-break-words">
                        {{ replyToMessage()!.content }}
                    </p>
                </div>
                <button (click)="cancelReply()"
                    class="tw-p-1 tw-text-gray-500 hover:tw-text-gray-700 dark:tw-text-gray-400 dark:hover:tw-text-gray-200 hover:tw-bg-gray-200 dark:hover:tw-bg-gray-700 tw-rounded">
                    <ng-icon name="heroXMark" size="16"></ng-icon>
                </button>
            </div>
        </div>
        }

        @if (activeConversation()) {
        <div class="tw-bottom-2 tw-rounded-2xl tw-border tw-border-gray-200/60 dark:tw-border-gray-800/60 tw-bg-white dark:tw-bg-gray-900 tw-shadow-lg tw-shadow-black/5 dark:tw-shadow-black/20 tw-backdrop-blur-xl tw-transition-all tw-duration-300 hover:tw-shadow-xl hover:tw-shadow-black/10 dark:hover:tw-shadow-black/30 focus-within:tw-border-blue-500/50 dark:focus-within:tw-border-blue-400/50 focus-within:tw-ring-4 focus-within:tw-ring-blue-500/10 dark:focus-within:tw-ring-blue-400/10 tw-sticky"
            [ngClass]="{'tw-mx-2':!isMobileView(),'tw-mx-1':isMobileView()}">

            <div class="tw-group tw-relative tw-overflow-hidden">
                <div class="tw-relative tw-flex tw-items-end tw-gap-3 tw-p-4">
                    <div class="tw-flex tw-gap-2">
                        <button [matMenuTriggerFor]="emojiMenu"
                            class="tw-flex tw-text-gray-500 dark:tw-text-gray-400 hover:tw-text-gray-700 dark:hover:tw-text-gray-300 hover:tw-bg-gray-200 dark:hover:tw-bg-gray-700 tw-rounded-xl tw-p-2 tw-transition-colors tw-duration-200">
                            <ng-icon name="heroFaceSmile" size="20"></ng-icon>
                        </button>

                        <button (click)="fileInput.click()"
                            class="tw-flex tw-text-gray-500 dark:tw-text-gray-400 hover:tw-text-gray-700 dark:hover:tw-text-gray-300 hover:tw-bg-gray-200 dark:hover:tw-bg-gray-700 tw-rounded-xl tw-p-2 tw-transition-colors tw-duration-200">
                            <ng-icon name="heroPaperClip" size="20"></ng-icon>
                        </button>
                    </div>

                    <div class="tw-flex-1 tw-flex">
                        <textarea #messageInput [ngModel]="newMessage()" (ngModelChange)="newMessage.set($event)"
                            (input)="onMessageInput(); adjustTextareaHeight()" (keydown.enter)="sendMessage($event)"
                            placeholder="Type your message..." rows="1"
                            class="tw-w-full tw-resize-none tw-border-0 tw-bg-transparent tw-px-4 tw-py-3 tw-text-gray-900 dark:tw-text-gray-100 tw-placeholder-gray-500 dark:tw-placeholder-gray-400 focus:tw-outline-none focus:tw-ring-0 tw-text-base tw-leading-relaxed tw-max-h-32 tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-thumb-gray-300 dark:tw-scrollbar-thumb-gray-600 tw-scrollbar-track-transparent">
                        </textarea>

                        @if (newMessage() && newMessage().length > 100) {
                        <div
                            class="tw-absolute tw-bottom-1 tw-right-1 tw-text-xs tw-text-gray-400 dark:tw-text-gray-500 tw-bg-white/90 dark:tw-bg-gray-900/90 tw-px-2 tw-py-1 tw-rounded-md tw-backdrop-blur-sm">
                            {{ newMessage().length }}
                        </div>
                        }
                    </div>

                    <button [disabled]="!newMessage().trim()" (click)="sendMessage()"
                        class="tw-group tw-relative tw-flex tw-items-center tw-justify-center tw-w-12 tw-h-12 tw-rounded-full tw-transition-all tw-duration-300 tw-overflow-hidden"
                        [ngClass]="newMessage().trim() ? 
              'tw-bg-gradient-to-br tw-from-blue-500 tw-to-blue-600 tw-shadow-lg tw-shadow-blue-500/30 hover:tw-shadow-xl hover:tw-shadow-blue-500/40 hover:tw-scale-105 active:tw-scale-95' : 
              'tw-bg-slate-200 dark:tw-bg-slate-700 tw-cursor-not-allowed'">
                        <div
                            class="tw-absolute tw-inset-0 tw-bg-white/20 tw-scale-0 group-active:tw-scale-100 tw-transition-transform tw-duration-150 tw-rounded-full">
                        </div>

                        <ng-icon name="heroPaperAirplane" size="20"
                            [class]="newMessage().trim() ? 'tw-text-white tw-transform group-hover:tw-translate-x-0.5 group-hover:tw--translate-y-0.5 tw-transition-transform' : 'tw-text-slate-400'">
                        </ng-icon>
                    </button>
                </div>
            </div>
        </div>
        }

        @if (!activeConversation()) {
        <div
            class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-8 tw-text-center tw-bg-gradient-to-br tw-from-gray-50 tw-to-gray-100/50 dark:tw-from-gray-950/50 dark:tw-to-gray-900/50">
            <div class="tw-max-w-md">
                <div
                    class="tw-mx-auto tw-h-48 tw-w-48 tw-flex tw-items-center tw-justify-center tw-bg-white dark:tw-bg-gray-900 tw-rounded-2xl tw-shadow-sm tw-p-6 tw-mb-6">
                    <ng-icon name="heroChatBubbleLeftRight"
                        class="tw-h-24 tw-w-24 tw-text-gray-300 dark:tw-text-gray-700" size="24"></ng-icon>
                </div>
                <h3 class="tw-text-2xl tw-font-semibold tw-text-gray-900 dark:tw-text-gray-100 tw-mb-3">No conversation
                    selected</h3>
                <p class="tw-text-gray-500/90 dark:tw-text-gray-400/90 tw-mb-6">Select a conversation from the list to
                    view
                    messages or start a new chat.</p>
            </div>
        </div>
        }
    </div>
</div>

<mat-menu #emojiMenu="matMenu" class="tw-emoji-menu">
    <div class="tw-max-w-xs tw-max-h-80 tw-overflow-hidden tw-rounded-lg tw-shadow-lg">
        <div class="tw-overflow-y-auto tw-max-h-64 tw-p-3">
            @for (category of emojiCategories; track $index) {
            <div class="tw-mb-4 last:tw-mb-0">
                <div
                    class="tw-text-xs tw-font-semibold tw-text-gray-600 dark:tw-text-gray-400 tw-mb-2 tw-px-1 tw-sticky tw-top-0 tw-bg-white dark:tw-bg-gray-900 tw-z-10">
                    {{ category.name }} ({{ category.emojis.length }})
                </div>
                <div class="tw-grid tw-grid-cols-8 tw-gap-1">
                    @for (emoji of category.emojis; track $index) {
                    <button (click)="addEmoji(emoji)"
                        class="tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-text-lg hover:tw-bg-gray-100 dark:hover:tw-bg-gray-800 tw-rounded-md tw-transition-all tw-duration-200 hover:tw-scale-110 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-ring-offset-1">
                        {{ emoji }}
                    </button>
                    }
                </div>
            </div>
            }

            @if (emojiCategories.length === 0) {
            <div class="tw-text-center tw-py-8 tw-text-gray-500 dark:tw-text-gray-400">
                <ng-icon name="heroFaceFrown" size="24" class="tw-mx-auto tw-mb-2"></ng-icon>
                <p class="tw-text-sm">No emojis found</p>
            </div>
            }
        </div>
    </div>
</mat-menu>


<mat-menu #messageContextMenu="matMenu" class="tw-message-context-menu">
    @if (selectedMessage()) {

    <button (click)="onReplyClick(selectedMessage()!)"
        class="tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 hover:tw-bg-gray-50 dark:hover:tw-bg-gray-800">
        <ng-icon name="heroArrowUturnLeft" size="16" class="tw-text-blue-600 dark:tw-text-blue-400"></ng-icon>
        <span>Reply</span>
    </button>

    @if (selectedMessage()?.type === 'text') {
    <button (click)="copyMessage(selectedMessage()!)"
        class="tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 hover:tw-bg-gray-50 dark:hover:tw-bg-gray-800">
        <ng-icon name="heroClipboard" size="16" class="tw-text-green-600 dark:tw-text-green-400"></ng-icon>
        <span>Copy Text</span>
    </button>

    @if (selectedMessage()?.userId == loggedUser?.id) {
    <button (click)="editMessage(selectedMessage()!)"
        class="tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 hover:tw-bg-gray-50 dark:hover:tw-bg-gray-800">
        <ng-icon name="heroPencil" size="16" class="tw-text-amber-600 dark:tw-text-amber-400"></ng-icon>
        <span>Edit</span>
    </button>
    }
    }

    @if (selectedMessage()?.type !== 'text') {
    <button (click)="downloadFile(selectedMessage()!)"
        [disabled]="!selectedMessage()?.fileUrl && !selectedMessage()?.fileId"
        class="tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 hover:tw-bg-gray-50 dark:hover:tw-bg-gray-800 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed">
        <ng-icon name="heroArrowDownTray" size="16" class="tw-text-indigo-600 dark:tw-text-indigo-400"></ng-icon>
        <span>Download {{ getMediaTypeLabel(selectedMessage()?.type!) }}</span>
    </button>

    }

    @if (selectedMessage()?.userId == loggedUser?.id) {
    <mat-divider class="tw-my-1"></mat-divider>

    <button (click)="onDeleteClick(selectedMessage()!)"
        class="tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-text-red-600 dark:tw-text-red-400 hover:tw-bg-red-50 dark:hover:tw-bg-red-900/20">
        <ng-icon name="heroTrash" size="16"></ng-icon>
        <span>Delete {{ selectedMessage()?.type === 'text' ? 'Message' : getMediaTypeLabel(selectedMessage()?.type!)
            }}</span>
    </button>
    }
    }
</mat-menu>


<input #fileInput type="file" multiple accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx,.zip,.rar"
    (change)="onFileSelect($event)" class="tw-hidden">
} @else {
<div class="tw-min-h-[calc(100dvh-65px)] tw-flex tw-items-center tw-justify-center">
    <div
        class="tw-bg-white/80 dark:tw-bg-gray-800/90 tw-backdrop-blur-sm tw-shadow-2xl tw-rounded-3xl tw-overflow-hidden tw-p-12 tw-text-center tw-border tw-border-white/20 dark:tw-border-gray-700/50">
        <div class="tw-mx-auto tw-max-w-md">
            <div
                class="tw-w-20 tw-h-20 tw-bg-gradient-to-r tw-from-orange-500 tw-to-safety-orange tw-rounded-2xl tw-shadow-lg tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-6">
                <!-- Chat Messages Icon -->
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="tw-w-10 tw-h-10 tw-text-white">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M8 9h8" />
                    <path d="M8 13h6" />
                    <path
                        d="M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z" />
                </svg>
            </div>
            <h2 class="tw-text-2xl tw-font-bold tw-text-gray-900 dark:tw-text-white tw-mb-4">
                Join the Conversation
            </h2>
            <p class="tw-text-gray-600 dark:tw-text-gray-300 tw-mb-8">
                Please login or register to access your messages and start chatting with your team.
            </p>
            <div class="tw-flex tw-flex-col sm:tw-flex-row tw-gap-4 tw-justify-center">
                <a (click)="authDialog.openLoginDialog()"
                    class="tw-px-6 tw-py-3 tw-bg-gradient-to-r tw-from-orange-500 tw-to-safety-orange tw-text-white tw-font-semibold tw-rounded-xl hover:tw-from-safety-orange hover:tw-to-orange-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-orange-500/50 tw-transition-all tw-duration-200 tw-shadow-lg hover:tw-shadow-xl">
                    Login
                </a>
                <a (click)="authDialog.openRegistrationDialog()"
                    class="tw-px-6 tw-py-3 tw-bg-gray-100 dark:tw-bg-gray-700 tw-text-gray-800 dark:tw-text-white tw-font-semibold tw-rounded-xl hover:tw-bg-gray-200 dark:hover:tw-bg-gray-600 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-gray-400/30 tw-transition-all tw-duration-200 tw-border tw-border-gray-200/50 dark:tw-border-gray-700/50">
                    Register
                </a>
            </div>
        </div>
    </div>

</div>
}